import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { PublicDutiesOption } from '../../../../../core';

@JsonConverter
export class PublicDutiesOptionAdapter implements JsonCustomConvert<PublicDutiesOption | undefined> {
    serialize(option: PublicDutiesOption | undefined): any {
        switch (option) {
            case PublicDutiesOption.POLITICAL:
                return '1';
            case PublicDutiesOption.SENIOR_JUDGES:
                return '2';
            case PublicDutiesOption.GOVERNMENT_INTERNATIONAL:
                return '3';
            case PublicDutiesOption.AMBASSADORS:
                return '4';
            case PublicDutiesOption.OTHERS:
                return '5';
        }

        return undefined;
    }

    deserialize(option: any): PublicDutiesOption | undefined {
        switch (String(option)) {
            case '1':
                return PublicDutiesOption.POLITICAL;
            case '2':
                return PublicDutiesOption.SENIOR_JUDGES;
            case '3':
                return PublicDutiesOption.GOVERNMENT_INTERNATIONAL;
            case '4':
                return PublicDutiesOption.AMBASSADORS;
            case '5':
                return PublicDutiesOption.OTHERS;
        }

        return undefined;
    }
}
